import useApi from '../../../services/useApi'

const useGetProjectStatuses = () => {
  const Api = useApi()
  const {data: response, isFetching} = Api.useGetQuery(`/agile/projects/card-status`)

  return {
    projectStatuses: response?.data || [],
    isLoading: isFetching,
  }
}

export default useGetProjectStatuses
